<!--
@修改人：谢汉
@修改时间：2019-03-13
@修改描述：新增日志统计tab
@版本:v2.0.3
--------
@修改人：黎柏祺
@修改时间：2018-12-05
@修改描述：新框架迁移
@版本:v1.0.26
--------
@修改人：谢汉
@修改时间：2018-11-15
@修改描述：增加本地下载功能
@版本:v1.0.26
--------
@修改人：黄志杰
@修改时间：2018-10-30
@修改描述：增加kibana帐号密码
@版本:v1.0.25
--------
@修改人：黎柏祺
@修改时间：2018-04-26
@修改描述：增加IP查询
@版本:v1.0.15
--------
@负责人: 谢汉
@创建时间: 2018-01-18
@版本:v1.0.12
@描述: 日志分析页
-->
<template>
  <div class="logAnalysis__content">
    <el-tabs type="border-card"  v-model="tabName">
      <el-tab-pane :label="$t('logAnalysis.logSearch')" :name="$t('logAnalysis.logSearch')">
        <log-search></log-search>
      </el-tab-pane>
      <el-tab-pane :label="$t('logAnalysis.offlineTask')" :name="$t('logAnalysis.offlineTask')">
        <offline-task ref="offlineTask"></offline-task>
      </el-tab-pane>
      <el-tab-pane :label="$t('logAnalysis.logStatistics')" :name="$t('logAnalysis.logStatistics')">
        <log-statistics :tab-name="tabName"></log-statistics>
      </el-tab-pane>
    </el-tabs>     
  </div>
</template>
<script>
  import logSearch from './logSearch'
  import offlineTask from './offlineTask'
  import logStatistics from './logStatistics'

  export default {
    components: {
      logSearch,
      offlineTask,
      logStatistics
    },
    data () {
      const that = this
      return {
        tabName: that.$t('logAnalysis.logSearch')
      }
    },
    methods: {},
    mounted () {}
  }
</script>